import React from 'react'
import { motion } from 'framer-motion'
import { techStack } from '../../assets'
import { techStackImgs } from '../../utils/constants'
import {Badge, ImageBuffer} from '../'
import './techStack.css'

const TechStack = () => {
  return (
    <>
      <section id='tech-stack' className='tech-stack-main-wrapper'>
        <Badge title="Tech Stack" />

        <div className='tech-stack-img-wrapper'>
          <div className='tech-stack-main-img'>
            <ImageBuffer src={techStack} alt='techStack' />
          </div>

          <div className="tech-stack-wrapper">
            <div className="tech-stack-gradient-top" />
            <div className="tech-stack-company-cover marquee-inner">
              <div className="tech-stack-company">
                {techStackImgs.map((result, index) => (
                  <div className='tech-stack-img-title-wrapper' key={index}>
                    <div className='tech-stack-company-images'>
                      <ImageBuffer key={index} src={result.image} alt='trusted companies' />
                    </div>
                    <span className='tech-stack-title'>
                      {result.title}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="tech-stack-gradient-bottom" />
          </div>
        </div>
      </section>
    </>
  )
}

export default TechStack